<template>
	<div>
		<FormGroupBox :icon="tripIcon" :title="`${this.$t('bookings.service')} #${serviceNumber}`">
			<b-form-row v-if="id>0" class="justify-content-end mt-2">
				<b-col cols="12" class="rounded bg-light-alt py-2 px-3">
					<small class="m-0 mr-2"><strong> {{ this.$t('bookings.serviceCreatedBy') }} </strong> {{ creationUser.firstName }} | {{ creationDatetimeStr }}</small>
					<b-badge v-if="domainPointOfsale !== false" size="sm" variant="primary"> {{ domainPointOfsale }}</b-badge>
				</b-col>
			</b-form-row>
			<hr>
			<b-form-row>
				<b-form-group v-if="!isNew" label-cols="6" label-size="sm" class="mr-3" :label="this.$t('global.status')" label-for="input-sm">
					<b-badge :variant="statusVariant" class="mt-2">
						{{ statusLabel }}
					</b-badge>
				</b-form-group>

				<b-form-group v-if="!isNew" label-cols="6" label-size="sm" :label="this.$t('bookings.paymentStatus')" label-for="input-sm">
					<b-badge variant="light" class="bg-light-alt">
						<md-icon class="text-success" icon="check" v-if="paymentStatus =='paid'"/>
						<md-icon icon="money_off_csred" v-if="paymentStatus =='pending'"/>
						<b-spinner variant="success" small type="grow" v-if="paymentStatus =='waiting'"/>
						{{itemPaymentStatus.text}}
						<md-icon v-if="ratePlanType != 'sc' && ratePlanType != '' && (status == 'active' || status == 'pending') && (paymentStatus != 'paid')"
							class="text-danger ml-1 shake"
							v-b-tooltip.hover
							v-b-tooltip.placement.right
							:title="this.$t('bookings.warningApiReservationPayment')"
							icon="warning"/>
					</b-badge>
				</b-form-group>
			</b-form-row>
			<hr>
			<b-row class="justify-content-between" no-gutters>
				<b-col md="5">
					<FormLocation
						:label="this.$t('bookings.pickup')"
						:place-id.sync="pickupPlaceId"
						:place.sync="pickup"
						:index="index"
					/>
				</b-col>
				<b-col md="5">
					<FormLocation
						:label="this.$t('bookings.dropoff')"
						:is-new="isNew"
						:place-id.sync="dropoffPlaceId"
						:place.sync="dropoff"
						:index="index"
						:unable-edit="unableEdit"
					/>
				</b-col>
				<b-col md="auto">
					<b-form-group class="text-center ml-1 mr-1" label=".">
						<b-button
							:href="routeUrl"
							target="_blank"
							size="sm"
							variant="info"
							v-b-tooltip.hover
							:title="$t('tooltips.viewRoute')"
						>
							<md-icon icon="directions"
							/>
						</b-button>
					</b-form-group>
				</b-col>
			</b-row>
			<FormFligh
				:index="index"
				v-if="requireFlightDatas"
				:unable-edit="unableEdit || this.id > 1"
			/>
			<FormPickup
				:index="index"
				:require-flight-datas="requireFlightDatas"
				:unable-edit="unableEdit || this.id > 1"
			/>
			<hr/>
			<b-form-row>
				<b-form-group class="col-md-4" :label="this.$t('bookings.serviceType')">
					<b-form-input size="sm" readonly v-if="serviceTypeName && ratePlanType != 'sc'" :value="serviceTypeName + ' - ' + ratePlanType"></b-form-input>
					<b-form-input
						v-else
						type="text"
						size="sm"
						:value="serviceType"
						readonly
						required
					/>
				</b-form-group>
				<b-form-group class="col-12" :label="this.$t('bookings.clientNotes')">
					<b-textarea
						:disabled="unableEdit"
						size="sm"
						v-model="clientNote"
					/>
				</b-form-group>
			</b-form-row>
			<b-form-row v-if="fromQuote">
				<b-col class="col-3 offset-9 mt-3">
					<b-card-group deck class="mb-3">
						<b-card no-body border-variant="light" header="Booking total" class="text-right">
							<b-card-text class="p-2"><h5 class="text-success text-right">${{ quote.bookingPriceTotal }}
								<span class="text-uppercase">{{ quote.bookingCurrency }}</span></h5></b-card-text>
						</b-card>
					</b-card-group>
				</b-col>

			</b-form-row>
		</FormGroupBox>

	</div>
</template>

<script>
import FormGroupBox from "@/components/helpers/FormGroupBox";
import {mapFields} from "../helpers/helpers";
import FormPickup from "./FormPickup";
import FormFligh from "./FormFlights";
import FormLocation from "./FormLocation.vue";
import MdIcon from '../../../helpers/MdIcon.vue';
import moment from "moment";

export default {
	props: {
		index: Number,
		model: {
			type: Object,
			required: true
		},
		enableCopy: {
			type: Boolean,
			required: true
		}
	},
	components: {
		FormFligh,
		FormPickup,
		FormLocation,
		FormGroupBox,
		MdIcon
	},
	beforeCreate() {
		this.$options.computed = {
			//El viewModel principal esta en el modulo reservation de vuex store
			...mapFields({
				fields: [
					"id",
					"status",
					"voucherUrl",
					"pickupPlaceId",
					"pickup",
					"dropoffPlaceId",
					"dropoff",
					"pointOfSale",
					"serviceTypeId",
					"serviceTypeName",
					"serviceNumber",
					"salesChannelId",
					"salesChannelReference",
					"fromQuote",
					"quote",
					"paymentStatus",
					"clientNote",
					"checkinStatus",
					"creationUser",
					"creationDatetime",
					"ratePlanType",
				],
				fieldArray: "transportServices",
				index: this.$options.propsData.index,
				base: "viewModel",
				mutation: "SET_UPDATE_MODEL_ARRAY",
				module: "reservation"
			}),
			creationDatetimeStr() {
				return moment(this.creationDatetime).format('DD/MMMM/YYYY HH:mm:ss')
			},
			canResetStatus() {
				return (
					this.$root.userCan("resetStatus") &&
					this.status !== "active" &&
					this.status !== "pending"
				);
			},
			statusLabel() {
				return this.$root.auxVars.transportServiceStatusOpts.find(
					status => status.value === this.status
				).text;
			},
			statusVariant() {
				return this.$root.auxVars.transportServiceStatusOpts.find(
					status => status.value === this.status
				).class;
			},
			routeUrl() {
				let originQuery;
				if (this.pickup.latitude && this.pickup.longitude) {
					originQuery = `${this.pickup.latitude},${this.pickup.longitude}`;
				} else {
					originQuery = encodeURIComponent(this.pickup.name);
				}
				let destinationQuery;
				if (this.dropoff.latitude && this.dropoff.longitude) {
					destinationQuery = `${this.dropoff.latitude},${this.dropoff.longitude}`;
				} else {
					destinationQuery = encodeURIComponent(this.dropoff.name);
				}
				return `https://www.google.com/maps/dir/?api=1&origin=${originQuery}&destination=${destinationQuery}&travelmode=driving`;
			},
			requireFlightDatas() {
				return this.pickup.isAirport || this.dropoff.isAirport;
			},

			unableEdit() {
				return this.status !== "active" && this.status !== "pending";
			},
			tripIcon() {
				if (this.pickup.isAirport) return "flight_land";
				//A2H
				else if (this.dropoff.isAirport) return "flight_takeoff";
				//H2A
				else return "place"; //P2P
			},

			isNew() {
				return this.id == -1;
			},

			transportStatusOpts() {
				if (this.isNew) {
					return [
						{value: "pending", text: this.$t('bookings.pending')},
						{value: "active", text: this.$t('bookings.active')}
					];
				} else {
					return this.$root.auxVars.transportServiceStatusOpts;
				}
			},
			serviceType() {
				const service = this.$root.auxVars.allServiceTypesOpts?.find(({value}) => value === this.serviceTypeId)
				return service ? service.text : ''
			},

			domainPointOfsale() {
				return this.pointOfSale?.domain ?? false;
			},
			itemPaymentStatus() {
				return this.$root.getItemFromAuxVarOpts("transportServicePaymentStatusOpts", this.paymentStatus)
			}

		};
	},
	methods: {
		emitDelete() {
			this.$emit("delete");
		},
		emitClone() {
			this.$emit("clone");
		},
	},
};
</script>

<style scoped>
.bg-light-alt {
	background-color: #e9ecef !important;
}
/* Animation property */
.shake {
    animation: wiggle 2s linear infinite;
}
/* Keyframes */
@keyframes wiggle {
    0%,
    7% {
        transform: rotateZ(0);
    }
    15% {
        transform: rotateZ(-15deg);
    }
    20% {
        transform: rotateZ(10deg);
    }
    25% {
        transform: rotateZ(-10deg);
    }
    30% {
        transform: rotateZ(6deg);
    }
    35% {
        transform: rotateZ(-4deg);
    }
    40%,
    100% {
        transform: rotateZ(0);
    }
}

</style>
